<template>
  <v-row class="mb-5">
    <v-col xs="12" sx="12" :md="size" :xl="size">
      <div class="upload-image">
        <div class="upload-image__cropper-wrapper">
          <cropper
            ref="cropper"
            class="upload-image__cropper"
            check-orientation
            :src="image.src"
            :default-size="defaultSize"
          />
          <v-btn
            icon
            class="upload-image__reset-button"
            title="Cancella immagine"
            @click="reset()"
            ><v-icon>mdi-cached</v-icon></v-btn
          >
          <div class="upload-image__file-type" v-if="image.type">
            {{ image.name }}<br />{{ image.type }}
          </div>
        </div>
        <div class="upload-image__buttons-wrapper">
          <button class="upload-image__button" @click="$refs.file.click()">
            <input
              ref="file"
              type="file"
              accept="image/*"
              @change="loadImage($event)"
            />
            Carica immagine
          </button>
          <button v-if="image.src" class="upload-image__button" @click="crop()">
            Salva
          </button>
        </div>
      </div>
    </v-col>
    <v-col xs="12" sx="12" :md="size" :xl="size">
      <v-card flat :loading="loading">
        <v-card-title>
          Elenco file caricati
          <v-btn icon class="ml-3">
            <v-icon @click="getDirList">mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <file-list
            :files="files"
            :moduli="moduli"
            @delete="onDeleteFile"
            @refresh="getDirList"
            @change="onChangeFileList"
            @edit="onEditImage"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
/*  eslint-disable */
/*
    https://advanced-cropper.github.io/vue-advanced-cropper/
    https://github.com/advanced-cropper/vue-advanced-cropper
    https://codesandbox.io/s/vue-advanced-cropper-desktop-without-theme-4pp9f?file=/src/App.vue:994-1059
    https://advanced-cropper.github.io/vue-advanced-cropper/introduction/getting-started.html#package-installation
    https://advanced-cropper.github.io/vue-advanced-cropper/guides/recipes.html#load-image-from-a-disc
    https://advanced-cropper.github.io/vue-advanced-cropper/guides/cross-origin.html#how-does-it-relate-to-cropper
  */
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import configurazioni from "@/services/configurazioniService";
import FileList from "./fileList";
import crypto from "crypto";

function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = "";
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case "89504e47":
      return "image/png";
    case "47494638":
      return "image/gif";
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return "image/jpeg";
    default:
      return fallback;
  }
}

export default {
  components: {
    FileList,
    Cropper,
  },
  props: {
    idProdotto: String,
    allegati: Array,
    triggerUpdate: Number,
    size: { type: Number, default: 6 },
  },
  data() {
    return {
      elencoFile: "",
      loading: false,
      files: [],
      moduli: [],
      image: {
        src: null,
        type: null,
        file: null,
      },
    };
  },
  async mounted() {
    await this.getDirList();
  },
  watch: {
    allegati(value) {
      Object.assign(this.files, this.allegati);
    },
    async triggerUpdate() {
      await this.getDirList();
    },
  },
  methods: {
    defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height,
      };
    },
    async crop() {
      // TODO: Il salvataggio dovrebbe passare per configurazioni e non direttamente verso licenze ...
      const info = await configurazioni.getInfoUpload();
      const { canvas } = this.$refs.cropper.getResult();
      const aggiunti = [];
      canvas.toBlob(async (blob) => {
        this.loading = true;
        const form_data = new FormData();
        const ff = this.image.file;
        const filename = this.idProdotto + ".png";
        form_data.append("attachment_multiple", blob, ff.name);
        const esistente = this.allegati.find((x) => x.name === ff.name);
        let daAggiungere = {
          name: ff.name,
          date: new Date(),
          description: esistente ? esistente.description || "" : "",
          type: ff.type,
          size: ff.size,
          lastModified: ff.lastModifiedDate,
          // pathFile: `${info.service}/utility/attachments/file?base=${info.base}&prodotto=${this.idProdotto}&fn=${ff.name}`,
          // Modificato path altrimenti problemi con tipo file in download (es Woocommerce)
          pathFile: `${info.service}/utility/attachments/filename/${ff.name}?base=${info.base}&prodotto=${this.idProdotto}`,
        };
        if (esistente) {
          daAggiungere.codice = esistente.codice;
        } else {
          daAggiungere.codice = crypto.randomBytes(16).toString("hex");
        }
        aggiunti.push(daAggiungere);
        // upload per allegati prodotto
        await configurazioni.uploadRepositoryMultipleFile(
          form_data,
          info.service,
          info.base,
          null,
          this.idProdotto
        );
        form_data.delete("attachment_multiple");
        form_data.append("attachment_multiple", blob, filename);
        const totems = await configurazioni.getConfigurazione("totem", "totem");
        daAggiungere.pathFile = `${info.service}/utility/attachments/file/${daAggiungere.codice}?base=${info.base}&totem=${totems[0].codice}&fn=${filename}`;
        //upload per totem
        await configurazioni.uploadRepositoryMultipleFile(
          form_data,
          info.service,
          info.base,
          null,
          null,
          totems[0].codice,
          daAggiungere.codice
        );
        aggiunti.push({
          actor: "totem",
          type: "image",
          id: totems[0].codice,
          operation: "update",
          tipo: "totem",
          idTotem: totems[0].codice,
          codice: daAggiungere.codice,
          payload: {
            fileCode: daAggiungere.codice,
            fileName: filename,
            filePath: daAggiungere.pathFile,
            destination: "assets/images/prodotti",
          },
        });

        this.$emit("change", {
          idProdotto: this.idProdotto,
          tipo: "addFile",
          payload: aggiunti,
        });
        setTimeout(async () => await this.getDirList(), 500);
        this.loading = false;
      }, this.image.type);
    },
    reset() {
      this.image = {
        src: null,
        type: null,
        file: null,
      };
    },
    loadImage(event) {
      const { files } = event.target;
      if (files && files[0]) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        const blob = URL.createObjectURL(files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = {
            name: files[0].name,
            src: blob,
            type: getMimeType(e.target.result, files[0].type),
            file: files[0],
          };
        };
        reader.readAsArrayBuffer(files[0]);
      }
    },
    previewImage(file) {
      if (file) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        fetch(file.pathFile)
          .then((response) => response.blob())
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            this.image = {
              src: url,
              type: file.type,
              file: file,
              name: file.name,
            };
          });
      }
    },
    onClearFile() {
      this.elencoFile = "";
    },
    async getDirList() {
      this.$emit("refresh");
      try {
        this.files = Object.assign([], this.allegati);
      } catch (err) {
        console.log(err);
      }
    },
    async onDeleteFile(file) {
      const info = await configurazioni.getInfoUpload();
      await configurazioni.deleteAttachmentFile(
        info.service,
        info.base,
        null,
        this.idProdotto,
        null,
        file.name
      );
      this.$emit("change", {
        idProdotto: this.idProdotto,
        tipo: "deleteFile",
        payload: file,
      });
      setTimeout(async () => await this.getDirList(), 500);
      this.reset();
    },
    onChangeFileList(file) {
      this.$emit("change", {
        idProdotto: this.idProdotto,
        tipo: "updateFile",
        payload: [file],
      });
      setTimeout(async () => await this.getDirList(), 500);
    },
    onEditImage(item) {
      this.previewImage(item);
    },
  },
  destroyed() {
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  },
};
</script>

<style lang="scss">
.img-canvas {
  width: 500px;
  height: 416px;
}

.cropper {
  background: #943e3e;
  &__image {
    opacity: 1;
  }
}
/* ----------------------------   */
.upload-image {
  margin-top: 20px;
  margin-bottom: 20px;
  user-select: none;

  &__cropper {
    border: solid 1px #eee;
    min-height: 300px;
    max-height: 500px;
    width: 100%;
  }

  &__cropper-wrapper {
    position: relative;
  }

  &__reset-button {
    position: absolute;
    right: 20px;
    bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 42px;
    background: rgba(#3fb37f, 0.7);
    transition: background 0.5s;
    &:hover {
      background: #3fb37f;
    }
  }

  &__buttons-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 17px;
  }

  &__button {
    border: none;
    outline: solid transparent;
    color: white;
    font-size: 16px;
    padding: 10px 20px;
    background: #3fb37f;
    cursor: pointer;
    transition: background 0.5s;
    margin: 0 16px;
    &:hover,
    &:focus {
      background: #38d890;
    }
    input {
      display: none;
    }
  }

  &__file-type {
    position: absolute;
    top: 20px;
    left: 20px;
    background: #0d0d0d;
    border-radius: 5px;
    padding: 0px 10px;
    padding-bottom: 2px;
    font-size: 12px;
    color: white;
  }
}
</style>
